import React from "react";
import { SITE } from "../site.config";

/**
 * Floating "Chat on WhatsApp" pill button bottom-right on desktop / tablet.
 * Hidden on mobile (<md) because the sticky bottom action bar already covers it.
 */
export default function FloatingWhatsApp() {
  return (
    <a
      data-testid="floating-whatsapp"
      href={SITE.whatsappUrl}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Chat on WhatsApp"
      className="hidden md:inline-flex fixed bottom-6 right-[210px] z-40 items-center justify-center hover:-translate-y-1 transition-transform"
    >
      <img
        src={SITE.whatsappButtonImg}
        alt="Chat on WhatsApp"
        className="h-14 md:h-16 w-auto rounded-full shadow-2xl"
        draggable="false"
      />
    </a>
  );
}
